// ----------------------------------------------------------------------------- //
// 	Update input number
// ----------------------------------------------------------------------------- //
export default function handleInputNumberChange( ref = document ) {

	const inputNumber = ref.querySelectorAll('.input-number');

	if ( inputNumber.length ) {
		inputNumber.forEach( (e) => {

			const input = e.querySelector('input');
			const btnDown = input.previousElementSibling;
			const btnUp = input.nextElementSibling;

			btnDown.addEventListener( "click", () => {
				const min = input.getAttribute('min');
				const oldValue = parseFloat( input.value );
				if ( oldValue > min || min === '' ) {
					input.value = oldValue - 1;
				}
			});

			btnUp.addEventListener( "click", () => {
				const max = input.getAttribute('max');
				const oldValue = parseFloat( input.value );
				if ( oldValue < max || max === '' ) {
					input.value = oldValue + 1;
				}
			});
		});
	}
};
